export const REQUEST_MASTER_RESTAURANT = "REQUEST_MASTER_RESTAURANT";
export const SET_MASTER_RESTAURANT = "SET_MASTER_RESTAURANT";
export const ERROR_GET_MASTER_RESTAURANT = "ERROR_GET_MASTER_RESTAURANT";

export const REQUEST_CREATE_MASTER_RESTAURANT = "REQUEST_CREATE_MASTER_RESTAURANT";
export const SUCCESS_CREATE_MASTER_RESTAURANT = "SUCCESS_CREATE_MASTER_RESTAURANT";
export const ERROR_CREATE_MASTER_RESTAURANT = "ERROR_CREATE_MASTER_RESTAURANT";

export const REQUEST_UPDATE_MASTER_RESTAURANT = "REQUEST_UPDATE_MASTER_RESTAURANT";
export const SUCCESS_UPDATE_MASTER_RESTAURANT = "SUCCESS_UPDATE_MASTER_RESTAURANT";
export const ERROR_UPDATE_MASTER_RESTAURANT = "ERROR_UPDATE_MASTER_RESTAURANT";

export const REQUEST_DELETE_MASTER_RESTAURANT = "REQUEST_DELETE_MASTER_RESTAURANT";
export const SUCCESS_DELETE_MASTER_RESTAURANT = "SUCCESS_DELETE_MASTER_RESTAURANT";
export const ERROR_DELETE_MASTER_RESTAURANT = "ERROR_DELETE_MASTER_RESTAURANT";

export const SET_MESSAGE_MASTER_RESTAURANT = "SET_MESSAGE_MASTER_RESTAURANT";